import { Controller } from "stimulus"
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';

export default class extends Controller {
  static targets = ['input', 'image', 'select', 'filename', 'modal', 'modalImage', "modalPreview"]

  cropper = null;
  newImg = false;

  connect() {
    this.fileReader = new FileReader();
    this.fileReader.addEventListener('load', (event) => {
      this.imageTarget.src = event.target.result
      this.modalImageTarget.src = event.target.result
      this.element.classList.remove('empty')
      this.filenameTarget.innerText = this.inputTarget.files[0].name;
      this.newImg = true;
    });

    this.selectTarget.addEventListener('dragenter', (e) => this.onDragEnter(e))
    this.selectTarget.addEventListener('dragleave', (e) => this.onDragLeave(e))
    this.selectTarget.addEventListener("dragover", function(event) {
      event.preventDefault();
    });
    this.selectTarget.addEventListener('drop', (e) => this.onDrop(e))
    this.cropper;
    this.urlToObject();
  }


  urlToObject= async() => {
    const response = await fetch(this.imageTarget.src);
    const blob = await response.blob();
    const file = new File([blob], this.filenameTarget.innerText, {type: blob.type});
    let container = new DataTransfer(); 
    container.items.add(file);
    this.inputTarget.files = container.files;
  }


  fileChanged(e) {
    this.fileReader.readAsDataURL(e.target.files[0]);
  }

  onDragEnter(e) {
    e.preventDefault();
    this.selectTarget.classList.add('drag-over');
  }

  onDragLeave(e) {
    e.preventDefault()
    this.selectTarget.classList.remove('drag-over')
  }

  onDrop(e) {
    e.preventDefault();
    this.inputTarget.files = e.dataTransfer.files
    this.fileReader.readAsDataURL(this.inputTarget.files[0])
    this.filenameTarget.innerText = this.inputTarget.files[0].name;
    this.selectTarget.classList.remove('drag-over')
    this.element.classList.remove('empty');
  }

  openModal(e) {
    this.modalTarget.style.display = "flex";
    if(this.cropper == null || this.newImg == false){
      this.cropper = new Cropper(this.modalImageTarget, {
        aspectRatio: 16 / 9,
        preview: this.modalPreviewTarget,
        checkCrossOrigin: false,
        checkOrientation: false,
      });
    }else {
      this.cropper.replace(this.imageTarget.src);
    }
    console.log(this.cropper);
  }

  closeModal(e){
    this.modalTarget.style.display = "none";
  }

  setMove(e) {
    this.cropper.setDragMode("move");
  }
  setCrop(e) {
    this.cropper.setDragMode("crop");
  }
  rotateLeft(e) {
    this.cropper.rotate(-45);
  }
  rotateRight(e) {
    this.cropper.rotate(45);
  }

  delete(e){
    this.element.classList.add('empty');
    this.imageTarget.src = 'https://via.placeholder.com/300x200';
    this.inputTarget.value = null;
    console.log(this.inputTarget.files);
  }
  saveModal(e){
    e.preventDefault();
    let dataURL = this.cropper.getCroppedCanvas({fillColor: '#ffffff'}).toDataURL();
    this.imageTarget.src = dataURL;
    let container = new DataTransfer(); 
    container.items.add(this.dataURLtoFile(dataURL));
    this.inputTarget.files = container.files;
    this.modalTarget.style.display = "none";
  }

   dataURLtoFile(dataURL) {
    var byteString = atob(dataURL.split(',')[1]);
    var mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
    
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    let file = new File([new Blob([ab], {type: mimeString})], this.filenameTarget.innerText,{type:"image/jpeg", lastModified:new Date().getTime()}, 'utf-8');
    return file
  }

  showStockImagesModal(){
    document.getElementById("stock-images-modal").classList.add("is-open");
  }
}